module.exports = __webpack_public_path__ + "2048df6253caeb85033fd43be155f278.svg";